import { useDictionaryContext } from 'application/contexts/DictionaryContext';
import { ActiveCampaignFeature } from './FormComponents/ActiveCampaignFeature';
import HubSpotFeature from './FormComponents/HubSpotFeature';
import { OrttoFeature } from './FormComponents/OrttoFeature';

export const FormFeature: React.FC<Content.Form> = ({ content }) => {
	const dictionary = useDictionaryContext();
	const kicker = {
		firstWord: content.properties.kickerFirstWord,
		secondWord: content.properties.kickerSecondWord,
	};

	const variant = content.properties.variant || 'Ortto'; // Default to 'Ortto' if variant is not specified

	return (
		<>
			{!variant ||
				(variant === 'Ortto' && (
					<OrttoFeature
						documentType="form"
						content={content}
						kicker={kicker}
						selectAllLabel={dictionary?.getValue('Form.SelectAllFormLabel')}
						placeholderLabel={dictionary?.getValue('Form.PlaceholderLabel')}
					/>
				))}
			{variant === 'ActiveCampaign' && (
				<ActiveCampaignFeature
					documentType="form"
					content={content}
					kicker={kicker}
					selectAllLabel={dictionary?.getValue('Form.SelectAllFormLabel')}
					placeholderLabel={dictionary?.getValue('Form.PlaceholderLabel')}
				/>
			)}
			{variant === 'HubSpot' && (
				<HubSpotFeature
					documentType="form"
					content={content}
					kicker={kicker}
					selectAllLabel={dictionary?.getValue('Form.SelectAllFormLabel')}
					placeholderLabel={dictionary?.getValue('Form.PlaceholderLabel')}
				/>
			)}
		</>
	);
};
